import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    requestedServices: [],
    assets: [],
    typesOfService: [],
    openedServiceRequests: [],
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {

    loadRS: (state, {payload}) => {
      state.requestedServices = payload.requestedServices
    },

    loadAssets: (state, {payload}) => {
      state.assets = payload.assets
    },

    loadTypesOfService: (state, {payload}) => {
      state.typesOfService = payload.typesOfService
    },

    loadOpenedServiceRequests: (state, {payload}) => {
      state.openedServiceRequests = payload.openedServiceRequests
    },

    clearDataHome: (state) => {
      state.requestedServices = []
      state.assets = []
      state.typesOfService = []
      state.openedServiceRequests = []
    },

  },

});

export const { loadRS, loadAssets, loadTypesOfService, loadOpenedServiceRequests, clearDataHome } = homeSlice.actions;

export default homeSlice.reducer;